<script lang="ts">

import { defineComponent } from 'vue'

import { useStoreWebcam } from '@/composables/useStoreWebcam'
import { getAssetURL } from '@/utils'

import CtaComponent from './CtaComponent.vue'

export default defineComponent({
  name: 'TheTitle',
  components: { CtaComponent },
  setup () {
    const { toggleWebcam } = useStoreWebcam()

    return {
      toggleWebcam,
      getAssetURL
    }
  }
})
</script>

<template>
  <section class="intro h-lview flex flex-col items-center text-center justify-center h-full gap-6 px-6 text-white uppercase offset-header offset-header-bottom">
    <div class="flex flex-col gap-2 items-center">
      <h1 class="subtitle-1">Dive in</h1>
      <h1 class="h1">Capri</h1>
      <h1 class="subtitle-2">with</h1>
      <img
        class="mt-2 sm:mt-0 max-w-40 xs:max-w-50 sm:max-w-60"
        :src="getAssetURL('textures/logo.png')"
        alt="D&G Beauty logo light blue summer vibes"
      />
    </div>

    <CtaComponent :is-primary="true" @click="toggleWebcam(true)">Enter</CtaComponent>
  </section>
</template>

<style scoped lang="scss">
//
</style>
